export function resolveMessagingThreadSelection(params: {
  initialThreadId?: string;
  selectThreadId?: string;
  urlThreadId?: string;
}): string | null {
  return params.initialThreadId ?? params.selectThreadId ?? params.urlThreadId ?? null;
}
